// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CaseDetails_root__8UsDL {
  width: 865px;
  padding: 15px;
  color: var(--color-font-10);
  overflow: scroll;
  margin-right: auto;
  margin-left: auto;
}

.CaseDetails_section_container__hiXS- {
  width: 850px;
  margin-bottom: 5px;
}

.CaseDetails_no_data__llxiq{
  text-align: center;
  margin-top: 300px;
  text-transform: uppercase;
  font-size: 24px;
  color: var(--color-theme-silver);
}

.CaseDetails_top_container__5yrcG{
  width: 850px;
  margin-bottom: 5px;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/@_components/CaseDetails/CaseDetails.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".root {\n  width: 865px;\n  padding: 15px;\n  color: var(--color-font-10);\n  overflow: scroll;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.section_container {\n  width: 850px;\n  margin-bottom: 5px;\n}\n\n.no_data{\n  text-align: center;\n  margin-top: 300px;\n  text-transform: uppercase;\n  font-size: 24px;\n  color: var(--color-theme-silver);\n}\n\n.top_container{\n  width: 850px;\n  margin-bottom: 5px;\n  display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `CaseDetails_root__8UsDL`,
	"section_container": `CaseDetails_section_container__hiXS-`,
	"no_data": `CaseDetails_no_data__llxiq`,
	"top_container": `CaseDetails_top_container__5yrcG`
};
export default ___CSS_LOADER_EXPORT___;
